export const LogIn = data => ({
	type: 'LOGGED_IN',
	data,
});

export const LogOut = () => ({
	type: 'LOGGED_OUT',
	data: {},
});
